import React, { useCallback, useState } from 'react';
import CustomIcon from 'components/Icon/CustomIcon';
import Comment from '@mui/icons-material/Comment';
import CommentForm, {
  CommentFormData,
  CommentFormProps,
} from 'components/CommentModal/CommentForm';
import Dialog from '@mui/material/Dialog';

interface CommentModalProps extends Omit<CommentFormProps, 'onCancel' | 'onSubmit'> {
  onSubmit: (data: CommentFormData) => Promise<boolean> | boolean | Promise<void> | void;
  buttonText?: string;
}

type Props = CommentModalProps;

const CommentModal = ({ onSubmit, title, buttonText, children, ...formProps }: Props) => {
  const [showCommentDialog, setShowCommentDialog] = useState(false);

  const handleCancel = useCallback(() => {
    setShowCommentDialog(false);
  }, []);

  const handleSubmit = useCallback(
    async (data: CommentFormData) => {
      const result = await onSubmit(data);
      if (result !== false) {
        setShowCommentDialog(false);
      }
    },
    [onSubmit]
  );

  return (
    <>
      <CustomIcon
        onClick={() => setShowCommentDialog(true)}
        label={buttonText}
        icon={<Comment />}
      />
      <Dialog open={showCommentDialog} onClose={handleCancel}>
        <CommentForm onSubmit={handleSubmit} title={title} onCancel={handleCancel} {...formProps}>
          {children}
        </CommentForm>
      </Dialog>
    </>
  );
};

export default CommentModal;
